// Where a visitor was going when they had to sign in first (spec/24 §4.1): the kiosk, or both side by side.
//
// The console's own sign-in page takes them back into the console when they are done, and the kiosk and the
// side-by-side view are not console routes, so the landing page and the kiosk note the page here before sending
// them to sign in, and the demo console's frame sends them on once they are signed in. Only the demo's own two
// pages are ever kept — never an address from a query string.

import { DEMO_NEXT_PAGE_KEY as KEY } from '@clavian/demo';

/** The demo pages a visitor may be sent on to after signing in. */
export const DEMO_NEXT_PAGES = ['/kiosk/', '/both'] as const;
export type DemoNextPage = (typeof DEMO_NEXT_PAGES)[number];

export function rememberNextPage(page: DemoNextPage): void {
  try {
    window.sessionStorage.setItem(KEY, page);
  } catch {
    // No session storage: they land in the console, which links to both.
  }
}

/** The page noted before sign-in, once — it is forgotten as it is read. */
export function takeNextPage(): DemoNextPage | null {
  try {
    const page = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    return (DEMO_NEXT_PAGES as readonly string[]).includes(page ?? '') ? (page as DemoNextPage) : null;
  } catch {
    return null;
  }
}
